import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/crms/crm-roles`;
export const modelName = 'crmrole';

export default {
  ...apiCrud({ baseUri, modelName }),
};
